import { useEffect, useRef } from "react";
import { TASK_ACTION_EVENT, takePendingTaskAction } from "./taskUtils";

/**
 * Runs `handler(request)` for task shortcuts of the given kinds — both for a
 * request broadcast while mounted and for one stashed before this view mounted.
 * `ready` delays pickup until the view can actually act (e.g. userId known).
 */
export default function useTaskActionListener(kinds, handler, ready = true) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  const kindsKey = kinds.join("|");

  useEffect(() => {
    if (!ready) return undefined;
    const list = kindsKey.split("|");
    const run = () => {
      const request = takePendingTaskAction(list);
      if (request) handlerRef.current(request);
    };
    run();
    window.addEventListener(TASK_ACTION_EVENT, run);
    return () => window.removeEventListener(TASK_ACTION_EVENT, run);
  }, [kindsKey, ready]);
}
